// Decide quando o polling de status de emissao (checkEmissionStatus, em
// confirmation-step.component.jsx) deve (re)comecar. Rastreia o orderId em
// vez de usar so um flag "ja iniciei": sem isso, compras seguidas na mesma
// sessao (o componente nunca desmonta entre elas) nunca disparam um novo
// polling, e o modal de confirmacao fica parado no pedido da compra anterior
// (Bug 7959).
export class EmissionPollingGate {
	constructor() {
		this.orderId = null
		this.started = false
	}

	// true quando o polling deve (re)comecar pro orderId informado - e passa
	// a bloquear chamadas subsequentes pro mesmo orderId ate reset() ou ate o
	// orderId mudar de novo.
	shouldStart(orderId) {
		if (orderId !== this.orderId) {
			this.orderId = orderId
			this.started = false
		}

		if (this.started) return false

		this.started = true
		return true
	}

	reset() {
		this.started = false
	}
}
